// antd theme variables for light theme
// ref: https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less

module.exports = {
  '@font-family': 'SatoshiMedium',
  '@code-family': '@font-family',

  '@text-color': '#25223b',
  '@primary-color': '#1890ff',
  '@info-color': '#1890ff',
  '@success-color': '#52c41a',
  '@processing-color': '#1890ff',
  '@error-color': '#f58300',
  '@highlight-color': '#f5222d',
  '@warning-color': '#faad14',
  '@normal-color': '#d9d9d9',

  '@body-background': '#ffffff',
  '@component-background': '#ffffff',
  '@heading-color': '#25223b',

  '@font-size-base': '15px',
  '@font-size-sm': '13px',
  '@font-size-lg': '17px',

  '@layout-body-background': 'transparent',
  '@layout-header-background': 'transparent',
  '@layout-footer-background': 'transparent',

  '@border-color-base': '#e8e8e8',
  '@border-color-split': '#e8e8e8',
  '@border-color-inverse': '#ffffff',
  '@border-radius-base': '0px',
  '@disabled-color': '#bfbfbc',
  '@disabled-bg': '#e8e8e8',

  '@btn-primary-color': '#ffffff',
  '@btn-primary-bg': '#1890ff',
  '@btn-default-color': '#25223b',
  '@btn-default-bg': '#ffffff',
  '@btn-danger-color': '#ffffff',
  '@btn-danger-bg': '#f5222d',
  '@btn-danger-border': '#f5222d',

  '@link-color': '#1890ff',
  '@link-hover-color': 'lighten(#1890ff, 8%)',
  '@link-active-color': 'darken(#1890ff, 10%)',

  '@item-active-bg': '#e6f7ff',
  '@item-hover-bg': '#e6f7ff',

  '@input-placeholder-color': 'lighten(#25223b, 10%)',
  '@input-color': '#25223b',
  '@input-addon-bg': '#f0f2f5',

  '@alert-success-border-color': '#b7eb8f',
  '@alert-success-bg-color': '#f6ffed',
  '@alert-success-icon-color': '#52c41a',
  '@alert-info-border-color': '#91d5ff',
  '@alert-info-bg-color': '#e6f7ff',
  '@alert-info-icon-color': '#1890ff',
  '@alert-warning-border-color': '#ffe58f',
  '@alert-warning-bg-color': '#fffbe6',
  '@alert-warning-icon-color': '#faad14',
  '@alert-error-border-color': '#ffa39e',
  '@alert-error-bg-color': '#fff1f0',
  '@alert-error-icon-color': '#f5222d',

  '@tabs-hover-color': '#40a9ff',
  '@tabs-active-color': '#096dd9',
  '@tabs-card-active-color': '#1890ff',
  '@tabs-ink-bar-color': '#1890ff',
  '@tabs-highlight-color': '#1890ff',

  '@table-header-bg': '#f0f2f5',
  '@table-header-color': '#25223b',
  '@table-footer-bg': '#f0f2f5',
  '@table-footer-color': '#25223b',
  '@table-row-hover-bg': '#e6f7ff',
  '@table-selected-row-bg': '#fafafa',
  '@table-expanded-row-bg': '#fbfbfb',

  '@label-required-color': '#f5222d',
  '@label-color': '#25223b',
}
